import { IAppState } from '../../../AppModulesWrapper';

import { EPaymentStatus } from '../../services/billingPayments';
import { selectRecommendedPackagePaymentStatus } from './selectRecommendedPackagePaymentStatus';

export const selectIsRecommendedPackagePaymentStatusCheckInProgress = (state: IAppState): boolean => {
  const status = selectRecommendedPackagePaymentStatus(state);

  return Boolean(status) && status !== EPaymentStatus.Succeeded;
};
